module.exports = __webpack_public_path__ + "img/SSE.11a57b43.svg";